if (!customElements.get('hero-video-sound')) {
  class HeroVideoSound extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.button = this.querySelector('.hero-video-sound__button');
      this.media = this.closest('.hero__media');
      this.video = this.media?.querySelector('video');

      if (!this.button || !this.video) {
        this.hidden = true;
        return;
      }

      this.dataset.initialized = 'true';
      this.video.autoplay = true;
      this.video.defaultMuted = true;
      this.video.muted = true;
      this.video.playsInline = true;
      this.updateState(false);

      this.handleClick = this.toggleSound.bind(this);
      this.handleKeyDown = this.onKeyDown.bind(this);
      this.handleResize = this.muteWhenHidden.bind(this);
      this.handleCanPlay = this.tryAutoplayMuted.bind(this);
      this.handleVisibilityChange = this.onVisibilityChange.bind(this);
      this.handleVideoClick = this.togglePlayback.bind(this);
      this.button.addEventListener('click', this.handleClick);
      this.button.addEventListener('keydown', this.handleKeyDown);
      this.video.addEventListener('click', this.handleVideoClick);
      this.video.addEventListener('canplay', this.handleCanPlay);
      this.video.addEventListener('loadeddata', this.handleCanPlay);
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
      window.addEventListener('pageshow', this.handleCanPlay);
      window.addEventListener('resize', this.handleResize, { passive: true });
      this.tryAutoplayMuted();
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleClick);
      this.button?.removeEventListener('keydown', this.handleKeyDown);
      this.video?.removeEventListener('click', this.handleVideoClick);
      this.video?.removeEventListener('canplay', this.handleCanPlay);
      this.video?.removeEventListener('loadeddata', this.handleCanPlay);
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      window.removeEventListener('pageshow', this.handleCanPlay);
      window.removeEventListener('resize', this.handleResize);
    }

    onKeyDown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      this.toggleSound();
    }

    mute() {
      if (!this.video) return;
      this.video.muted = true;
      this.updateState(false);
    }

    muteWhenHidden() {
      const { width, height } = this.getBoundingClientRect();
      if (width === 0 || height === 0) this.mute();
    }

    tryAutoplayMuted() {
      if (!this.video?.paused || this.dataset.soundEnabled === 'true') return;
      const { width, height } = this.media.getBoundingClientRect();
      if (width === 0 || height === 0) return;
      this.video.muted = true;
      this.video.play().catch(() => {});
    }

    onVisibilityChange() {
      if (document.visibilityState === 'visible') this.tryAutoplayMuted();
    }

    togglePlayback() {
      if (!this.video.paused) {
        this.video.pause();
        this.mute();
        return;
      }

      this.mute();
      this.video.play().catch(() => {});
    }

    toggleSound() {
      if (this.video.paused) {
        this.mute();
        return;
      }

      const shouldEnableSound = this.video.muted;

      this.closest('.hero__inner')
        ?.querySelectorAll('hero-video-sound')
        .forEach((control) => {
          if (control !== this) control.mute();
        });

      this.video.muted = !shouldEnableSound;
      this.video.volume = 1;
      this.updateState(!this.video.muted);
    }

    updateState(soundEnabled) {
      this.dataset.soundEnabled = String(soundEnabled);
      this.button.setAttribute('aria-pressed', String(soundEnabled));
      this.button.setAttribute('aria-label', soundEnabled ? 'Mute video' : 'Unmute video');
    }
  }

  customElements.define('hero-video-sound', HeroVideoSound);
}
